export default "__VITE_ASSET__185ae262__"